import React from 'react'

const HiddenEyeIcon = (props) => {
  return (
    <svg
      width={12}
      height={12}
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_9344_499)'>
        <path
          d='M1.96496 8.44125L2.50121 7.90875C1.91404 7.38154 1.4527 6.72926 1.15121 6C1.91246 4.09875 4.01246 2.625 5.99996 2.625C6.51141 2.63189 7.01822 2.72311 7.49996 2.895L8.08121 2.31C7.42226 2.03131 6.71537 1.88357 5.99996 1.875C4.77766 1.92096 3.59561 2.32408 2.59991 3.03453C1.60422 3.74498 0.838523 4.73162 0.397463 5.8725C0.367675 5.95489 0.367675 6.04511 0.397463 6.1275C0.730555 7.01138 1.26762 7.80414 1.96496 8.44125Z'
          fill='#3D4058'
        />
        <path
          d='M4.5 5.89875C4.52608 5.53939 4.68063 5.20143 4.93541 4.94666C5.19018 4.69188 5.52814 4.53733 5.8875 4.51125L6.56625 3.82875C6.18591 3.7286 5.78596 3.72991 5.40628 3.83252C5.0266 3.93514 4.68046 4.13549 4.40235 4.4136C4.12424 4.69171 3.92389 5.03785 3.82127 5.41753C3.71866 5.79721 3.71735 6.19716 3.8175 6.5775L4.5 5.89875ZM11.6025 5.8725C11.1725 4.75245 10.4243 3.78263 9.45 3.0825L11.25 1.27875L10.7213 0.75L0.75 10.7213L1.27875 11.25L3.19125 9.3375C4.04402 9.83759 5.01154 10.1089 6 10.125C7.22231 10.079 8.40435 9.67592 9.40005 8.96547C10.3957 8.25502 11.1614 7.26838 11.6025 6.1275C11.6323 6.04511 11.6323 5.95489 11.6025 5.8725ZM7.5 6C7.49842 6.26254 7.42796 6.52006 7.29566 6.74684C7.16337 6.97361 6.97387 7.16169 6.7461 7.29227C6.51834 7.42286 6.26029 7.49137 5.99775 7.49098C5.73521 7.49058 5.47737 7.42128 5.25 7.29L7.29 5.25C7.42482 5.47715 7.49726 5.73587 7.5 6ZM6 9.375C5.21327 9.36126 4.44146 9.15801 3.75 8.7825L4.7025 7.83C5.13575 8.13062 5.66083 8.26951 6.18605 8.22243C6.71127 8.17534 7.20327 7.94528 7.57615 7.5724C7.94903 7.19952 8.17909 6.70752 8.22618 6.1823C8.27326 5.65708 8.13437 5.132 7.83375 4.69875L8.91 3.6225C9.77047 4.21312 10.4434 5.03828 10.8488 6C10.0875 7.90125 7.9875 9.375 6 9.375Z'
          fill='#3D4058'
        />
      </g>
      <defs>
        <clipPath id='clip0_9344_499'>
          <rect width={12} height={12} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default HiddenEyeIcon
